<template>
  <TableTemplate
    v-model="tableResult"

    :columns="websiteColumns"
    :columnVariables="websiteColumnVariables"
    :capitalize="capitalize"
    :skeletonClass="skeletonClass"

    :page="page"
    :enable-sorting="true"

    @update-column-order="updateColumnOrder"
    @set-page="v => page = v"
    :on-row-click="editSynonym"

    :max="max"

    ref="table"
  >
    <template #above>
      <TableHeader
        title="Synoniem"
        :alwaysShowMultiSelectCheckbox="true"
        :removeColumnConfiguration="true"
        :exportParams="exportEndpointParams"
        :refetch="refetch"

        @customize-layout="customizeLayout"
      >
        <template #header-buttons-before="props">
          <slot name="header-buttons-before" v-bind="props"></slot>
        </template>
        <template #after-title>
          <HeaderButton class="ml-2"
                        buttonTypeClass="btn-outline-primary btn-primary-secondary-outline"
                        style="padding: 11px 8px"
                        @click.native="addSynonym"
          >
            Synoniem toevoegen
          </HeaderButton>
        </template>
      </TableHeader>

      <div class="d-flex">
        <TableMainSearchField v-model="search"/>
        <RefreshBtn
          :loading="isLoadingTableResult"
          @click.native="refresh"
        />
      </div>
    </template>

    <template #cell-synonyms="{ item }">
      <div class="TAILWIND flex">
        <span
          v-for="syn in item.synonyms"
          :key="syn"

          class="mr-2 inline-flex items-center rounded-xs bg-yellow-100 px-2 py-0.5 text-xs font-medium text-yellow-800"
        >
          <span style="display: inline-block;transform: translateY(2px)">{{ syn }}</span>
        </span>
      </div>
    </template>

    <template v-if="loaded" #row-action="{item}">
      <div class="delete-icon" @click="confirmDelete(item)">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
        </svg>
      </div>
    </template>

    <template #empty-state>
      <EmptyStatePlaceholder
        title="Er zijn geen synoniemen"
      >
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
          <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 21l5.25-11.25L21 21m-9-3h7.5M3 5.621a48.474 48.474 0 016-.371m0 0c1.12 0 2.233.038 3.334.114M9 5.25V3m3.334 2.364C11.176 10.658 7.69 15.08 3 17.502m9.334-12.138c.896.061 1.785.147 2.666.257m-4.589 8.495a18.023 18.023 0 01-3.827-5.802" />
        </svg>
      </EmptyStatePlaceholder>
    </template>
  </TableTemplate>
</template>

<script>

import TableTemplate from 'src/layout/Table/TableTemplate'
import tableFieldOptions from "src/mixins/tableFieldOptions"
import TableSearchField from "src/components/Inputs/TableSearchField.vue"
import TableActionDropdown from "src/components/Inputs/TableActionDropdown.vue"
import EmptyStatePlaceholder from "src/layout/EmptyStatePlaceholder.vue"
import HeaderButton from "src/components/Inputs/HeaderButton.vue"
import TableHeader from "src/components/Product/ProductTable/TableHeader.vue"
import TableMainSearchField from '../layout/TableMainSearchField.vue'
import RefreshBtn from '../layout/RefreshBtn.vue'

import TableCell from "src/components/Table/TableCell.vue"

import table from "src/mixins/table"

export default {
  metaInfo: {
    title: "Synoniemen",
  },
  components: {
    TableCell,
    TableMainSearchField,
    TableTemplate,
    TableSearchField,
    TableHeader,
    TableActionDropdown,
    RefreshBtn,
    EmptyStatePlaceholder,
    HeaderButton,
  },
  mixins: [
    tableFieldOptions,
    table({
      pageReference: 'synonyms',
      page_size: 100,
      params: {
        search: "",
      },
      route: "/api/synonyms",
    }),
  ],
  methods: {
    addSynonym() {
      this.$pushModal({
        modal: "EditSynonym",
        toBind: {
          callback: this.freshRefetch,
        },
      })
    },
    editSynonym(synonym) {
      this.$pushModal({
        modal: "EditSynonym",
        toBind: {
          synonym: this.tableResult.find(item => item.uid === synonym.uid),
          callback: this.freshRefetch,
        },
      })
    },
    async deleteSynonym(uid) {
      await this.$handlePromise(
        this.axios.delete(`/api/synonyms/${uid}`)
      )
      this.$store.dispatch('clearCacheSearch', "synonyms")
      this.$success("Productgroup succesvol verwijderd!")
      this.freshRefetch()
    },
    confirmDelete(item) {
      this.$confirmAction(
        () => this.deleteSynonym(item.uid),
        {
          title: "Productgroup verwijderen",
          description: `Are you sure you want to delete the <b>${item.name}</b> product group?`,
          buttonSave: "Verwijderen",
        }
      )
    },
  },
  computed: {
    table() {
      return this.$refs.table
    },
    websiteColumns() {
      return ['Naam', "Synoniemen"]
    },
    websiteColumnVariables() {
      return ['name', "synonyms"]
    },
    capitalize() {
      return [false]
    },
  },
}

</script>

<style scoped>

.synonym {

}

</style>
